import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../Theme/ThemeProvider';

const LoadingAuthComponent: React.FC = () => {
  const { mode } = useTheme();

  // Determine panel styling based on mode for subtle contrast
  const panelClasses = mode === 'dark'
    ? 'bg-[var(--color-secondary)]/40 border-2 border-[var(--color-accent)] backdrop-blur-sm'
    : 'bg-white/70 border border-[var(--color-border)] backdrop-blur-sm shadow-lg';

  return (
    <div
      className="flex flex-col items-center justify-center h-screen w-full bg-[var(--main-background)] text-[var(--color-text)]"
      role="status"
      aria-live="polite"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className={`flex flex-col items-center gap-8 px-10 py-12 rounded-xl ${panelClasses}`}
        style={{ minWidth: '300px', maxWidth: '480px' }}
      >
        {/* Logo */}
        <div className="flex items-center justify-center">
          <img
            src={mode === 'dark' ? '/logo-dark.png' : '/logo-light.png'}
            alt="Logo"
            className="h-12"
            style={{ filter: mode === 'dark' ? 'drop-shadow(0 2px 4px rgba(0,0,0,0.6))' : 'none' }}
          />
        </div>

        {/* Spinner */}
        <div className="relative flex items-center justify-center">
            <div
              className="spinner"
              style={{
                width: '40px',
                height: '40px',
                border: mode === 'dark' ? '4px solid rgba(255,255,255,0.15)' : '4px solid rgba(0,0,0,0.15)',
                borderTop: mode === 'dark' ? '4px solid var(--color-text)' : '4px solid var(--color-accent)',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}
              aria-label="Loading"
            />
        </div>

        {/* Pulsing text */}
        <motion.h2
          className="text-lg font-semibold tracking-wide text-center"
          initial={{ opacity: 0.5 }}
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
        >
          Authenticating your session...
        </motion.h2>

        {/* Sub text */}
        <p className="text-xs text-[var(--color-text)]/70 text-center max-w-xs leading-relaxed">
          Hang tight while we securely verify your credentials.
        </p>
      </motion.div>
    </div>
  );
};

export default LoadingAuthComponent;
